<ng-container *ngIf="loading$ | async; let loading">
  <div class="peca-loading-overlay" [hidden]="!loading">
    <div class="loader"></div>
  </div>
</ng-container>
